import {UtilityService} from '../service/utility.service';

/**
 * @class
 * @description This class maintains the model structure for a PrismHR PEO's API credentials.
 * @export
 * @name PeoApiCredentialModel
 */
export class PeoApiCredentialModel {

  /**
   * @description This method is a factory method that creates a new instance of the PeoApiCredentialModel.
   * @memberof PeoApiCredentialModel
   * @method
   * @name PeoApiCredentialModel.Factory()
   * @param {string} peoId The PEO ID for the PEO for the PrismHR API.
   * @returns {PeoApiCredentialModel} Returns a new instance of the PeoApiCredentialModel.
   * @public
   */
  public static Factory(peoId: string): PeoApiCredentialModel {

    // Instantiate a new instance of the PeoApiCredentialModel.
    const model: PeoApiCredentialModel = new PeoApiCredentialModel();

    // Set the PEO ID in the model.
    model.peoId = peoId;

    // We're done, return the model.
    return model;
  }

  /**
   * @default UtilityService.DateTimeUtc()
   * @description This property contains the timestamp at which the PEO API credentials were created.
   * @memberof PeoApiCredentialModel
   * @name PeoApiCredentialModel#created
   * @property
   * @public
   * @type {Date}
   */
  public created: Date = UtilityService.DateTimeUtc();

  /**
   * @description This property contains the password for the PEO for the PrismHR API.
   * @memberof PeoApiCredentialModel
   * @name PeoApiCredentialModel#peoId
   * @property
   * @public
   * @type {string}
   */
  public password!: string;

  /**
   * @description This property contains the PEO ID for the PEO for the PrismHR API.
   * @memberof PeoApiCredentialModel
   * @name PeoApiCredentialModel#peoId
   * @property
   * @public
   * @type {string}
   */
  public peoId!: string;

  /**
   * @default UtilityService.DateTimeUtc()
   * @description This property contains the timestamp at which the PEO API credentials were last updated.
   * @memberof PeoApiCredentialModel
   * @name PeoApiCredentialModel#updated
   * @property
   * @public
   * @type {Date}
   */
  public updated: Date = UtilityService.DateTimeUtc();

  /**
   * @description This property contains the URL for the PEO for the PrismHR API.
   * @memberof PeoApiCredentialModel
   * @name PeoApiCredentialModel#url
   * @property
   * @public
   * @type {string}
   */
  public url!: string;

  /**
   * @description This property contains the username for the PEO for the PrismHR API.
   * @memberof PeoApiCredentialModel
   * @name PeoApiCredentialModel#username
   * @property
   * @public
   * @type {string}
   */
  public username!: string;
}
